import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

/**
 * Toolbar with highlight and navigation arrows
 */
const NavigationToolbar = ({
  onHighlightClick,
  onPrevClick,
  onNextClick,
  hasPrev = false,
  hasNext = false,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "16px",
        padding: "8px 12px",
        backgroundColor: "#f7f7f7",
        borderRadius: "5px",
        marginBottom: "12px",
        justifyContent: "space-between",
      }}
    >
      {/* Highlighter Button */}
      <button
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: "4px",
        }}
        onClick={onHighlightClick}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.164062 16V13.7554H15.1282V16H0.164062ZM9.36849 7.12946L7.42315 5.18413L4.47335 8.13374C4.43021 8.17689 4.40863 8.22964 4.40863 8.29199C4.40863 8.35434 4.43021 8.40715 4.47335 8.45042L6.0906 10.0791C6.13387 10.1222 6.18668 10.1438 6.24903 10.1438C6.31138 10.1438 6.36413 10.1222 6.40728 10.0791L9.36849 7.12946ZM8.22298 4.39571L10.1569 6.32944L13.3512 3.14676C13.3943 3.10362 13.4159 3.04844 13.4159 2.98123C13.4159 2.91401 13.3943 2.85883 13.3512 2.81568L11.7367 1.20143C11.6936 1.15828 11.6385 1.13671 11.5714 1.13671C11.5042 1.13671 11.449 1.15828 11.4058 1.20143L8.22298 4.39571ZM7.04026 3.98999L10.5626 7.51217L7.2073 10.8791C6.93669 11.1496 6.61914 11.2848 6.25464 11.2848C5.89014 11.2848 5.57265 11.1496 5.30218 10.8791L5.23016 10.8071L4.54537 11.446H1.63896L3.76555 9.33087L3.70794 9.27345C3.43746 9.00284 3.29836 8.68149 3.29063 8.30938C3.28302 7.93715 3.41445 7.6158 3.68493 7.34532L7.04026 3.98999ZM7.04026 3.98999L10.6245 0.405715C10.895 0.135238 11.2125 0 11.577 0C11.9415 0 12.2591 0.135238 12.5297 0.405715L14.1583 2.02296C14.4288 2.29344 14.564 2.61093 14.564 2.97543C14.564 3.33993 14.4288 3.65742 14.1583 3.92789L10.5626 7.51217L7.04026 3.98999Z"
            fill="#6C757D"
          />
        </svg>
      </button>

      {/* Navigation Arrows */}
      <div>
        <button
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
          }}
          onClick={onPrevClick}
          disabled={!hasPrev}
        >
          <FontAwesomeIcon
            icon={faArrowUp}
            color={hasPrev ? "#000" : "#ccc"}
            size="lg"
          />
        </button>

        <button
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            marginLeft: "10px",
          }}
          onClick={onNextClick}
          disabled={!hasNext}
        >
          <FontAwesomeIcon
            icon={faArrowDown}
            color={hasNext ? "#000" : "#ccc"}
            size="lg"
          />
        </button>
      </div>
    </div>
  );
};

export default NavigationToolbar;
